exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".receipt_body{display:flex;flex-direction:column;padding:0 24px;flex:70%}.receipt_body_row{color:#000;opacity:.5;font-family:Avenir-Roman;font-size:15px;display:flex;flex-direction:row;justify-content:space-between;margin:16px 0}.receipt_body_row.total{font-family:Platform-Medium;font-size:15px;opacity:1}", ""]);

// exports
